import * as swcHelpers from '@swc/helpers';
import { useLink } from '@grandvisionhq/frk-routing';
import { useIntl } from '@grandvisionhq/state';
import { getParsedDataFromLS } from '../Util/customer-name-persistor.js';

function getActivePath() {
    if (typeof window === 'undefined') {
        return '';
    }
    const url = new URL(window.location.href);
    return url.pathname;
}
function hasRoute(route) {
    return Boolean(route);
}
const useMyAccountMenuItems = ({ logout , routes , isUserLoggedIn , isAddressBookEnabled , isAabEnabled  })=>{
    const intl = useIntl();
    const activePath = getActivePath();
    const loginLinkAttributes = useLink({
        route: 'auth.login'
    });
    const profileLinkAttributes = useLink({
        route: 'me.profile'
    });
    const addressBookLinkAttributes = useLink({
        route: 'me.address-book'
    });
    const prescriptionsLinkAttributes = useLink({
        route: 'me.prescription'
    });
    const ordersLinkAttributes = useLink({
        route: 'me.orders'
    });
    const appointmentsLinkAttributes = useLink({
        route: 'me.appointments'
    });
    const subscriptionsLinkAttributes = useLink({
        route: 'me.subscriptions'
    });
    const settingsLinkAttributes = useLink({
        route: 'me.settings'
    });
    const getLinkAttributes = (linkProps, { highlightOnUrlPath , isLinkEnabled , skipHighlight =false  } = {})=>{
        if (!isLinkEnabled) {
            return undefined;
        }
        var ref;
        const active = activePath.startsWith((ref = highlightOnUrlPath !== null && highlightOnUrlPath !== void 0 ? highlightOnUrlPath : linkProps === null || linkProps === void 0 ? void 0 : linkProps.href) !== null && ref !== void 0 ? ref : 'unknown');
        var ref1, ref2;
        return swcHelpers.objectSpread({
            type: 'external'
        }, !skipHighlight ? {
            active
        } : null, {
            href: (ref1 = linkProps === null || linkProps === void 0 ? void 0 : linkProps.href) !== null && ref1 !== void 0 ? ref1 : '',
            onClick: (ref2 = linkProps === null || linkProps === void 0 ? void 0 : linkProps.onClick) !== null && ref2 !== void 0 ? ref2 : undefined
        });
    };
    const logoutItem = {
        label: intl.getLabel('account.menu.logOut'),
        parameters: {
            icon: 'logout',
            action: logout,
            testId: 'logout'
        },
        childMenuItems: [],
        link: {
            href: '',
            type: 'external'
        }
    };
    const loginItem = {
        label: intl.getLabel('account.action.login'),
        childMenuItems: [],
        parameters: {
            testId: 'login'
        },
        link: getLinkAttributes(loginLinkAttributes, {
            isLinkEnabled: hasRoute(routes === null || routes === void 0 ? void 0 : routes.profile),
            skipHighlight: true
        })
    };
    function getProfileChildMenuItems() {
        const items = [];
        if (isAddressBookEnabled) {
            items.push({
                label: intl.getLabel('account.menu.addresses'),
                link: getLinkAttributes(addressBookLinkAttributes, {
                    highlightOnUrlPath: profileLinkAttributes === null || profileLinkAttributes === void 0 ? void 0 : profileLinkAttributes.href,
                    isLinkEnabled: hasRoute(routes === null || routes === void 0 ? void 0 : routes.profile)
                }),
                parameters: {
                    testId: 'addressBook'
                }
            });
        }
        return items;
    }
    const userHasParsedDataFromLS = getParsedDataFromLS();
    let lastItem = logoutItem;
    if (!isUserLoggedIn && !userHasParsedDataFromLS) {
        lastItem = loginItem;
    }
    const items1 = [
        {
            label: intl.getLabel('account.menu.accountDetails'),
            parameters: {
                icon: 'user',
                testId: 'profile'
            },
            link: getLinkAttributes(profileLinkAttributes, {
                isLinkEnabled: hasRoute(routes === null || routes === void 0 ? void 0 : routes.profile)
            }),
            childMenuItems: getProfileChildMenuItems()
        },
        {
            label: intl.getLabel('account.menu.appointments'),
            parameters: {
                icon: 'calendar',
                testId: 'appointments'
            },
            link: getLinkAttributes(appointmentsLinkAttributes, {
                isLinkEnabled: isAabEnabled && hasRoute(routes === null || routes === void 0 ? void 0 : routes.appointments)
            })
        },
        {
            label: intl.getLabel('account.menu.prescriptions'),
            parameters: {
                icon: 'frame',
                testId: 'prescriptions'
            },
            link: getLinkAttributes(prescriptionsLinkAttributes, {
                isLinkEnabled: hasRoute(routes === null || routes === void 0 ? void 0 : routes.prescriptions)
            })
        },
        {
            label: intl.getLabel('account.menu.orders'),
            parameters: {
                icon: 'orders',
                testId: 'orders'
            },
            link: getLinkAttributes(ordersLinkAttributes, {
                isLinkEnabled: hasRoute(routes === null || routes === void 0 ? void 0 : routes.orders)
            })
        },
        {
            label: intl.getLabel('account.menu.subscriptions'),
            parameters: {
                icon: 'shipment-next',
                testId: 'subscriptions'
            },
            link: getLinkAttributes(subscriptionsLinkAttributes, {
                isLinkEnabled: hasRoute(routes === null || routes === void 0 ? void 0 : routes.subscriptions)
            })
        },
        {
            label: intl.getLabel('account.menu.settings'),
            parameters: {
                icon: 'folded-page-with-text',
                testId: 'settings'
            },
            link: getLinkAttributes(settingsLinkAttributes, {
                isLinkEnabled: hasRoute(routes === null || routes === void 0 ? void 0 : routes.settings)
            })
        },
        lastItem, 
    ];
    const hasLink = (item)=>{
        var ref;
        return ((ref = item.link) === null || ref === void 0 ? void 0 : ref.href) && item.link.href !== '';
    };
    const hasAction = (item)=>{
        var ref;
        return (ref = item.parameters) === null || ref === void 0 ? void 0 : ref.action;
    };
    return items1.filter((item)=>hasLink(item) || hasAction(item)
    );
};

export { useMyAccountMenuItems };
//# sourceMappingURL=use-my-account-menu-items.js.map
